import axios, { AxiosHeaders, InternalAxiosRequestConfig } from 'axios'
import getBearerToken from '@js/api/utils/getBearerToken'

/**
 * Extend InternalAxiosRequestConfig to allow custom recaptcha token
 */
export interface MagentoRequestConfig extends InternalAxiosRequestConfig {
  recaptchaToken?: string
}

const magentoAxios = axios.create()

// Request interceptor
magentoAxios.interceptors.request.use((config) => {
  const cfg = config as MagentoRequestConfig

  // Ensure headers is an instance of AxiosHeaders for consistent manipulation
  if (!(cfg.headers instanceof AxiosHeaders)) {
    cfg.headers = AxiosHeaders.from(cfg.headers)
  }

  // Add Authorization header if token exists 
  const token = getBearerToken()
  if (token) {
    cfg.headers.set('Authorization', `Bearer ${token}`)
  }

  // Add recaptcha token header if it exists in the config
  if (cfg.recaptchaToken) {
    cfg.headers.set('X-ReCaptcha', cfg.recaptchaToken)
  }

  return cfg
})

export default magentoAxios
